export default "__VITE_ASSET__CTK11dFq__"